module.exports = __webpack_public_path__ + "static/media/mapfre-economics-logo.744773e3.png";